import { Component, EventEmitter, Input, Output } from '@angular/core';
import { isEqual } from 'lodash';
import { inputTypesEnum } from '../../enums/input-types.enum';
import { InputValidationModel } from '../../../../Common/Forms/models/input-validation.model';

// @TODO remove and replace with <agpr-text-input-chips>
@Component({
    selector: 'agpr-monitoring-keywords-input',
    templateUrl: './monitoring-keywords-input.component.html',
    styleUrls: ['./monitoring-keywords-input.component.scss'],
    standalone: false
})
export class MonitoringKeywordsInputComponent {
    @Input() id: string = null;
    @Input() label: any = null;
    @Input() labelType: inputTypesEnum = inputTypesEnum.html;
    @Input() styleClass: string | object = null;
    @Input() keywordValidations: InputValidationModel[] = [];
    @Input() placeholder: string = 'Monitoring.search.enterKeywordsOrPhrases';
    @Input() disabled: boolean = false;

    @Input() value: string[];
    oldValue: string[];

    @Output() valueChange: EventEmitter<string[]> = new EventEmitter();

    splitOnPattern: RegExp = /(")?,(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)\1 */g;
    inputTypesEnum = inputTypesEnum;

    handleChanges(): void {
        if (!isEqual(this.oldValue, this.value)) {
            this.oldValue = this.value?.slice();
            this.valueChange.emit(this.value);
        }
    }
}
